import { useLocation, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'

import type { TourPage } from './steps'

const PAGE_SUFFIX: Record<TourPage, string> = {
  overview: '',
  coverage: '/insights/coverage',
  transactions: '/transactions',
  categories: '/insights/categories',
  reconciliation: '/insights/reconciliation',
}

const withoutTrailingSlash = (path: string) => path.replace(/\/$/, '')

// Opens the step's page when the step changes. The tour ends once the user goes to another page
// themselves (a coverage month opens the reconciliation page, for example), since its area is gone.
export const useFollowStepPage = (
  projectPath: string,
  page: TourPage,
  onEnd: () => void,
) => {
  const navigate = useNavigate()
  const pathname = withoutTrailingSlash(useLocation().pathname)
  const stepPath = `${projectPath}${PAGE_SUFFIX[page]}`
  const latestPathname = useRef(pathname)
  latestPathname.current = pathname
  const hasArrived = useRef(false)

  useEffect(() => {
    hasArrived.current = latestPathname.current === stepPath
    if (!hasArrived.current) navigate({ to: stepPath })
  }, [stepPath, navigate])

  useEffect(() => {
    if (pathname === stepPath) {
      hasArrived.current = true
      return
    }
    if (hasArrived.current) onEnd()
  }, [pathname, stepPath, onEnd])
}
